import { render, staticRenderFns } from "./InitializeAccount.vue?vue&type=template&id=abdbe2e6&scoped=true"
import script from "./InitializeAccount.vue?vue&type=script&lang=js"
export * from "./InitializeAccount.vue?vue&type=script&lang=js"
import style0 from "./InitializeAccount.vue?vue&type=style&index=0&id=abdbe2e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdbe2e6",
  null
  
)

export default component.exports